import { getTags, getDimensionsObject } from "../../../helpers";
import { TooltipTag } from "../../shared/TooltipTag";
import { BaseDesignStudioItemCardProps } from "../DesignStudioItemCard";

export const CardTags = ({ item }: BaseDesignStudioItemCardProps) => {
  const tags = getTags(item);
  const [first, ...rest] = tags;
  const dimensions = getDimensionsObject(item);
  const dimensionsTag = `${dimensions?.width}x${dimensions?.height}`;

  if (!tags.length && !dimensions) return null;
  if (tags.length)
    return (
      <div>
        <TooltipTag title={dimensionsTag}>{dimensionsTag}</TooltipTag>
        <TooltipTag title={first}>{first}</TooltipTag>
        {rest.length > 0 && (
          <TooltipTag title={rest.join(", ")}>+{rest.length}</TooltipTag>
        )}
      </div>
    );

  return (
    <div>
      <TooltipTag title={dimensionsTag}>{dimensionsTag}</TooltipTag>
    </div>
  );
};
